module.exports = __webpack_public_path__ + "static/media/noInvoiceVector.d88f5219.png";